<template>
    <div class="error-page">
        <v-img src="images/warning.svg" />
        <div class="error-message">
            <h1 class="primary--text">{{ $t("error.not_found") }}</h1>
            <p>{{ $t("error.not_found_message") }}</p>
            <v-btn color="primary" elevation="0" @click="$router.push(-1)">
                {{ $t("error.back") }}
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: "Error404",
};
</script>
